import { createApp } from 'vue'
import App from './App.vue'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { createI18n } from 'vue-i18n'
import el from '@/locale/el'
import { aliases, mdi } from 'vuetify/lib/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'
import { createPinia } from 'pinia'
import router from '@/router'
import 'vue3-carousel/dist/carousel.css'
import '@/assets/styles/global.css'

createApp(App)
    .use(createPinia())
    .use(router)
    .use(
        createI18n({
            locale: 'el',
            allowComposition: true,
            messages: { el }
        })
    )
    .use(
        createVuetify({
            components,
            directives,
            icons: {
                defaultSet: 'mdi',
                aliases,
                sets: {
                    mdi
                }
            }
        })
    )
    .mount('#app')
